/**
 * Le logo de l'en-tête (RDEC-020). Sous 768 px, le monogramme seul : le logo
 * complet y réduisait « REGISTRY » à 3 px. Au-delà, le logo complet. `<picture>`
 * ne télécharge que la version affichée.
 */
export const BrandMark = () => (
  <picture>
    <source media="(min-width: 768px)" srcSet="/provena-logo-clair.svg" />
    <img
      src="/provena-monogram-clair.svg"
      alt="Provena Registry"
      data-testid="brand-mark"
      className="h-12 md:h-20 w-auto object-contain"
    />
  </picture>
);

export default BrandMark;
